import type { IconSvgObject } from './types';

const InvoiceIcon: IconSvgObject = [
  ["path", { d: "M10 8C8.89543 8 8 8.67157 8 9.5C8 10.3284 8.89543 11 10 11C11.1046 11 12 11.6716 12 12.5C12 13.3284 11.1046 14 10 14M10 8C10.8708 8 11.6116 8.4174 11.8862 9M10 8L10 7M10 14C9.12919 14 8.38836 13.5826 8.1138 13M10 14V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 2L4 2C2.89543 2 2 2.89543 2 4L2 21.5L6 19.5L10 22L14 19.5L18 21.5V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 8H22V4C22 2.89543 21.1046 2 20 2C18.8954 2 18 2.89543 18 4V8Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default InvoiceIcon;
